import type { OrderInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'
import type { ShopCartProduct } from '@components/order/types'

import { gql } from '@apollo/client'

import { ORDER_TOTALS_FIELDS } from '@@partner:graphql/shortcuts'

export interface UpdateOrderProductMutation {
  updated: {
    updatedOrder: OrderInfo
    updatedProduct: ShopCartProduct
  }
}
export interface UpdateOrderProductMutationVariables {
  order_id: GQL_ID
  orderProduct: {
    product_id: GQL_ID
    amount: number
  }
}

export const GQL_MUTATION_UPDATE_ORDER_PRODUCT = gql`
  mutation($order_id: ID!, $orderProduct: OrderProductInput!) {
    updated: updateOrderProduct(
      order_id: $order_id
      orderProduct: $orderProduct
    ) {
      updatedOrder: order {
        id
        ${ORDER_TOTALS_FIELDS}
      }
      updatedProduct {
        id: product_id
        amount: count
        total
      }
    }
  }
`
